import React,{useState} from 'react'
import {ROOM_OPTIONS,COUNT_OPTIONS} from '../constant'
import InputField from "../components/InputFeild";
import SelectField from '../components/SelectField';

const Booking = ({show}) => {
  
    const [room,setRoom]=useState()
    const [children,setChildren]=useState()
    const [adult,setAdult]=useState()
    const [name,setName]=useState()
    const [email,setEmail]=useState()
    const [contact,setContact]=useState()
    const [date,setDate]=useState()
    const [time,setTime]=useState()
    const [person,setPerson]=useState()
    const [arrival,setArrival]=useState()
    const [departure,setDeparture]=useState()

  if(show) {
    return (
   <div className="container shadow-lg w-4/5 mx-auto p-3 py-6">
        <div className="content-evenly grid md:grid-rows-2 md:grid-cols-6 md:grid-flow-col gap-4 text-xl sm:grid-rows-12 sm:grid-cols-1 sm:grid-flow-row">
         <span>Name</span>
         <span><InputField type="text" value={name}  onChange={(e) => setName(e.target.value)}/></span>
        <span>Email</span>
         <span><InputField type="email" value={email}  onChange={(e) => setEmail(e.target.value)}/></span>
         <span>Contact Number</span>
        <span><InputField type="number" value={contact}  onChange={(e) => setContact(e.target.value)}/></span>
        <span>Date</span>
        <span><InputField type="date" value={date}  onChange={(e) => setDate(e.target.value)}/></span>
        <span>Time</span>
        <span><InputField type="time" value={time}  onChange={(e) => setTime(e.target.value)}/></span>
        <span>Number of Persons</span>
         <span><InputField type="number" value={person}  onChange={(e) => setPerson(e.target.value)} /></span>
    
           <span></span>
          <span>
            <button className="w-full text-center font-semibold bg-[#d2a960] text-white  border-none px-4 py-2">BOOK NOW</button>
  </span>
           
    </div>
    </div>
  )
  }
  else{
    return (
   <div className="container shadow-lg w-4/5 mx-auto p-3 py-6">
        <div className="content-evenly grid md:grid-rows-2 md:grid-cols-6 md:grid-flow-col gap-4 text-xl sm:grid-rows-12 sm:grid-cols-1 sm:grid-flow-row">
         <span>Arrival Date</span>
         <span><InputField type="date"  value={arrival} onChange={(e) => setArrival(e.target.value)}/></span>

        <span>Departure Date</span>
        <span><InputField type="date"  value={departure} onChange={(e) => setDeparture(e.target.value)}/></span>
        <span>Room</span>
         <span><SelectField 
          options={ROOM_OPTIONS}
          changeHandler={setRoom}
          selectedValue={room}/></span>
         <span>Adults</span>
         <span><SelectField 
          options={COUNT_OPTIONS} changeHandler={setAdult}
          selectedValue={adult}/></span>
          <span>Children</span>
         
         
            
            
           
          
          <span><SelectField 
         options={COUNT_OPTIONS} changeHandler={setChildren}
          selectedValue={children}/></span>
           <span></span>
          <span>
            <button className="w-full text-center font-semibold bg-[#d2a960] text-white  border-none px-4 py-2">BOOK NOW</button>
  </span>
           
    </div>
    </div>
  )
}
}

export default Booking